var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPallet = function SvgPallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#pallet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.429.857H2.57c-.946 0-1.714.768-1.714 1.714v18.857c0 .947.768 1.715 1.714 1.715H21.43c.946 0 1.714-.768 1.714-1.715V2.572c0-.946-.768-1.714-1.714-1.714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.429.857V9.43a.857.857 0 0 1-.858.857H9.43a.857.857 0 0 1-.858-.857V.857M14.571 18.857h4.286"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pallet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPallet;